import { render, staticRenderFns } from "./SubscriptionManager.vue?vue&type=template&id=2d4c3356&scoped=true"
import script from "./SubscriptionManager.vue?vue&type=script&lang=js"
export * from "./SubscriptionManager.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionManager.vue?vue&type=style&index=0&id=2d4c3356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c3356",
  null
  
)

export default component.exports